import {Injectable} from "@angular/core";
import { UserInformations } from "../resources/auth/resources.auth";

@Injectable()
export class UserStore {

  private user: UserInformations;

  constructor() {
  }

  setUser(user: UserInformations) {
    this.user = user;
  }

  getUser(): UserInformations {
    return this.user;
  }
  
  public isAdmin(): boolean {
    return this.user.role == "ADMINISTRATEUR";
  }

  public getLogin(): string {
    return this.user.login;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/store/user.store.ts